import { applyMiddleware, legacy_createStore as createStore } from "redux";
import { thunk } from "redux-thunk";
import { composeWithDevTools } from "@redux-devtools/extension";

import { rootReducer } from "./store";

const loadState = () => {
  // Load and validate persisted state here.
  return undefined;
};

export const setupStore = () => {
  const preloadedState = loadState();

  const store = createStore(rootReducer, preloadedState, composeWithDevTools(applyMiddleware(thunk)));

  store.subscribe(() => {
    // saveState(store.getState());
  });

  return store;
};
